import Vue from 'vue'
import moment from 'moment'
import axios from 'axios'

export const isRoute = (route, url) => {
  return route.matched.some(({name}) => name === url)
}
export const redirect = (router, url) => {
  return router.push(url)
  // return window.history.pushState({}, null, url)
}
export const goToPerson = (router, accountId, personId) => {
  return router.push('/account-insights/' + accountId + '?person=' + personId)
  // return window.history.pushState({}, null, url)
}

export const redirectOutside = (url) => {
  window.location.href = url
  return ''
}
export const apiUrl = () => {
  return process.env.UNRIVAL_API
}
export const generateUrl = (params, prependQuestion = true) => {
  return (prependQuestion ? '?' : '') + Object.keys(params).map(key => key + '=' + params[key]).join('&')
}

export const userImageURL = (key) => {
  return key || '/static/user_profile_02.svg'
}
export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getColor = (name) => {
  let colors = [
    '#04B486',
    '#CF2662',
    '#404040',
    '#D3F0E8',
  ]
  let val = name.toUpperCase().charCodeAt(1)
  if (val < 71) {
    return colors[0]
  } else if (val < 77) {
    return colors[1]
  } else if (val < 83) {
    return colors[2]
  } else {
    return colors[3]
  }
}

export const calculateSeniority = (num) => {
  let opposite = num * 10
  let perc = 100 - opposite
  if (perc > 100) {
    return 100
  }
  if (perc < 0) {
    return 0
  }
  return perc
}
export const seniorityLabel = (num) => {
  if (num < 30) {
    return 'Low seniority'
  }
  if (num < 70) {
    return 'Medium seniority'
  }
  return 'High seniority'
}

export const getCookie = (s, def) => {
  let value = window.$cookies.get(s)
  if (value == null) {
    return def
  }
  return value
}

export const setCookie = (s, value) => {
  return window.$cookies.set(s, value)
}

export const formatMonthYear = (date) => {
  return moment(date).format('MMM YYYY')
}

export const imageUrl = (type, assetUrls = null, size = 0) => {
  if (assetUrls) {
    if ((size === 0 || size === 1) && assetUrls.small) {
      return assetUrls.small
    }
    if (size === 2 && assetUrls.medium) {
      return assetUrls.medium
    }
    if (size === 3 && assetUrls.original) {
      return assetUrls.original
    }
  }

  if (type === 'account') {
    return null
  } else if (type === 'client') {
    return null // TODO: client placeholder?
  } else if (type === 'country') {
    return null // TODO: country placeholder?
  } else if (type === 'person') {
    return '/static/user_profile_03.svg'
  }
  return null
}
export const imageErr = (e) => {
  e.target.src = '/static/user_profile_03.svg'
}

export const getClientColor = (name) => {
  let colors = [
    '#04B486',
    '#CF2662',
    '#497B9F',
    '#384E70',
    '#D3F0E8',
    '#3A878B',
  ]
  let val = name.toUpperCase().charCodeAt(1)

  if (val < 69) {
    return colors[0]
  } else if (val < 74) {
    return colors[1]
  } else if (val < 79) {
    return colors[2]
  } else if (val < 83) {
    return colors[3]
  } else if (val < 87) {
    return colors[4]
  } else {
    return colors[5]
  }
}



// WEBPACK FOOTER //
// ./src/service/helpers.js